document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
if (menuToggle && mobileMenu) {
  menuToggle.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!open));
    mobileMenu.classList.toggle('is-open', !open);
    document.body.classList.toggle('menu-open', !open);
  });
}

const variantSelect = document.querySelector('[data-variant-select]');
if (variantSelect) {
  variantSelect.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantSelect.value);
    window.history.replaceState({}, '', url);
  });
}
